/* Turkish Printed Rayon Jacquard: one customer page, actual Shopify data.
   Main product + photographed support variants; no design/color name dictionary.
   The native picker/gallery remain available if media validation fails. */
(function () {
  'use strict';
  var MAIN = 'turkish-printed-rayon-viscose-jacquard-fabric';
  if (location.pathname.replace(/\/$/, '') !== '/products/' + MAIN) return;
  var dataElement = document.getElementById('hiba-turkish-merged-catalog-data');
  if (!dataElement || window.__hibaTurkishMergedInstalled) return;
  window.__hibaTurkishMergedInstalled = true;
  var data;
  try { data = JSON.parse(dataElement.textContent); }
  catch (error) { window.__hibaTurkishMergedError = 'invalid-json'; return; }
  if (!data || !Array.isArray(data.sources) || data.sources.length !== 2) {
    window.__hibaTurkishMergedError = 'invalid-sources';
    return;
  }

  var allVariants = [], designs = [], byVariant = {}, byDesign = {};
  var current = null, root = null, gallery = null, slides = null;
  var picker = null, originalGallery = null, styleTag = null;
  var updatePending = false, observer = null;

  function normalizedImage(url) {
    if (!url) return '';
    try {
      return decodeURIComponent(new URL(String(url), location.origin).pathname)
        .toLowerCase().replace(/_(?:\d+x\d*|pico|thumb|small|compact|medium|large|grande|master)(?=\.[a-z0-9]+$)/, '');
    } catch (e) { return String(url).split('?')[0].toLowerCase(); }
  }
  function mediaForVariant(sourceData, variant, catalogProduct) {
    var list = (catalogProduct.images || []).map(function (image) {
      return typeof image === 'string' ? image : (image && (image.src || image.url)) || '';
    });
    var ajaxVariant = (catalogProduct.variants || []).find(function (v) {
      return String(v.id) === String(variant.id);
    });
    var firstPhoto = (ajaxVariant && ajaxVariant.featured_image &&
        ajaxVariant.featured_image.src) || variant.featured;
    var anchor = normalizedImage(firstPhoto);
    var index = list.findIndex(function (url) { return normalizedImage(url) === anchor; });
    if (index < 0 || index % 6 !== 0 || index + 6 > list.length) return null;
    var images = list.slice(index, index + 6);
    if (images.some(function (url) { return !url; })) return null;
    return images;
  }
  function loadSource(source) {
    if (!source.handle) return Promise.reject(new Error('missing-source-handle'));
    return fetch('/products/' + encodeURIComponent(source.handle) + '.js',
      { credentials:'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('source-not-public:' + source.handle);
        return response.json();
      }).then(function (product) {
        if (!product || !Array.isArray(product.images) ||
            !Array.isArray(product.variants)) {
          throw new Error('invalid-source-product:' + source.handle);
        }
        return product;
      });
  }
  function prepareCatalog() {
    return Promise.all(data.sources.map(loadSource)).then(function (products) {
      data.sources.forEach(function (source, sourceIndex) {
        var product = products[sourceIndex];
        (source.variants || []).forEach(function (variant) {
          if (!variant.design || !variant.color || !variant.featured) {
            throw new Error('missing-variant-label-or-photo:' + variant.id);
          }
          var photos = mediaForVariant(source, variant, product);
          if (!photos) throw new Error('incomplete-photo-group:' + variant.id);
          var item = {
            id: String(variant.id),
            design: String(variant.design).trim(),
            color: String(variant.color).trim(),
            hex: String(variant.hex || '#CCCCCC'),
            available: !!variant.available,
            photos: photos,
            source: source.handle,
            price: variant.price
          };
          if (!byDesign[item.design]) {
            var group = { name:item.design, variants:[], thumb:photos[0] };
            byDesign[item.design] = group;
            designs.push(group);
          }
          if (byDesign[item.design].variants.some(function (v) { return v.color === item.color; })) {
            throw new Error('duplicate-design-color:' + item.design + '/' + item.color);
          }
          byDesign[item.design].variants.push(item);
          allVariants.push(item);
          byVariant[item.id] = item;
        });
      });
      if (designs.length !== 20 || allVariants.length !== 56) {
        throw new Error('unexpected-catalog-count:' + designs.length + '/' + allVariants.length);
      }
      return true;
    });
  }
  function el(tag, classname, content) {
    var node = document.createElement(tag);
    if (classname) node.className = classname;
    if (content != null) node.textContent = String(content);
    return node;
  }
  function chosenForm() {
    var info = document.querySelector('product-info[data-product-handle="' + MAIN + '"]');
    return info && info.querySelector('form[action*="/cart/add"]');
  }
  function synchronizeForm() {
    if (!current || !root || !root.isConnected) return;
    var info = root.closest('product-info');
    if (!info) return;
    info.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
        if (String(input.value) !== current.id) input.value = current.id;
        input.disabled = !current.available;
      });
      form.querySelectorAll('button[data-add-to-cart]').forEach(function (button) {
        button.disabled = !current.available;
        button.setAttribute('aria-disabled', String(!current.available));
      });
    });
    info.querySelectorAll('[data-hiba-fabric-box]').forEach(function (box) {
      box.dataset.meterVariantId = current.id;
    });
  }
  function renderPhotos(variant) {
    var fragment = document.createDocumentFragment();
    variant.photos.forEach(function (url, index) {
      var slide = el('div', 'hiba-turkish-merged-slide');
      var img = el('img');
      img.src = url;
      img.alt = variant.design + ' in ' + variant.color +
        ', Turkish Printed Rayon Viscose Jacquard fabric — image ' + (index + 1);
      img.loading = index < 2 ? 'eager' : 'lazy';
      img.decoding = 'async';
      if (index === 0) img.fetchPriority = 'high';
      slide.appendChild(img);
      fragment.appendChild(slide);
    });
    slides.replaceChildren(fragment);
    slides.scrollLeft = 0;
    gallery.dataset.selectedDesign = variant.design;
    gallery.dataset.selectedColor = variant.color;
    gallery.dataset.variantId = variant.id;
    gallery.dataset.imagesCount = '6';
  }
  function selectVariant(variant, rerenderDesigns) {
    if (!variant || !slides || !root) return;
    var designChanged = !current || current.design !== variant.design;
    var imageChanged = !current || current.id !== variant.id;
    current = variant;
    var designLabel = root.querySelector('[data-hiba-turkish-selected-design]');
    var colorLabel = root.querySelector('[data-hiba-turkish-selected-color]');
    designLabel.textContent = variant.design;
    colorLabel.textContent = variant.color;
    root.querySelectorAll('[data-hiba-turkish-design-id]').forEach(function (button) {
      var selected = button.dataset.hibaTurkishDesignId === variant.design;
      button.setAttribute('aria-pressed', String(selected));
    });
    if (designChanged || rerenderDesigns) {
      renderColors(variant.design);
    }
    root.querySelectorAll('[data-hiba-turkish-variant-id]').forEach(function (button) {
      button.setAttribute('aria-pressed',
        String(button.dataset.hibaTurkishVariantId === variant.id));
    });
    var availability = root.querySelector('[data-hiba-turkish-availability]');
    availability.textContent = variant.available ? '' : 'This color is currently unavailable.';
    if (imageChanged) renderPhotos(variant);
    synchronizeForm();
  }
  function renderColors(design) {
    var container = root.querySelector('[data-hiba-turkish-colors]');
    var fragment = document.createDocumentFragment();
    (byDesign[design]?.variants || []).forEach(function (variant) {
      var button = el('button','hiba-turkish-merged-swatch');
      button.type = 'button';
      button.dataset.hibaTurkishVariantId = variant.id;
      button.style.setProperty('--hiba-turkish-swatch', variant.hex);
      button.setAttribute('aria-label', variant.color + (variant.available ? '' : ' — unavailable'));
      button.setAttribute('title', variant.color);
      button.setAttribute('aria-pressed', String(variant.id === current.id));
      if (!variant.available) button.classList.add('is-unavailable');
      var dot = el('span', 'hiba-turkish-merged-swatch-dot');
      dot.setAttribute('aria-hidden','true');
      button.appendChild(dot);
      button.addEventListener('click', function () { selectVariant(variant, false); });
      fragment.appendChild(button);
    });
    container.replaceChildren(fragment);
  }
  function renderPicker() {
    root = el('div','hiba-turkish-merged-picker');
    root.id = 'hiba-turkish-merged-picker';
    root.innerHTML =
      '<div class="hiba-turkish-merged-label">Design: <span data-hiba-turkish-selected-design></span></div>' +
      '<div class="hiba-turkish-merged-designs" data-hiba-turkish-designs role="group" aria-label="Fabric designs"></div>' +
      '<div class="hiba-turkish-merged-label">Color: <span data-hiba-turkish-selected-color></span></div>' +
      '<div class="hiba-turkish-merged-colors" data-hiba-turkish-colors role="group" aria-label="Fabric colors"></div>' +
      '<div class="hiba-turkish-merged-availability" data-hiba-turkish-availability aria-live="polite"></div>';
    var container = root.querySelector('[data-hiba-turkish-designs]');
    var fragment = document.createDocumentFragment();
    designs.forEach(function (group) {
      var button = el('button','hiba-turkish-merged-design');
      button.type = 'button';
      button.dataset.hibaTurkishDesignId = group.name;
      button.title = group.name;
      button.setAttribute('aria-label',group.name);
      button.setAttribute('aria-pressed','false');
      var img = el('img');
      img.src = group.thumb;
      img.alt = group.name;
      img.loading = 'lazy';
      button.appendChild(img);
      button.addEventListener('click', function () {
        var preferred = group.variants.find(function (v) {
          return current && v.color === current.color;
        });
        selectVariant(preferred || group.variants.find(function (v) {
          return v.available;
        }) || group.variants[0],false);
      });
      fragment.appendChild(button);
    });
    container.appendChild(fragment);
  }
  function makeGallery() {
    gallery = el('div','product__images hiba-turkish-merged-gallery');
    gallery.id = 'hiba-turkish-merged-gallery';
    gallery.setAttribute('role','region');
    gallery.setAttribute('aria-label','Turkish Printed Rayon fabric photographs');
    slides = el('div','hiba-turkish-merged-gallery-list');
    gallery.appendChild(slides);
  }
  function addStyles() {
    if (document.getElementById('hiba-turkish-merged-styles')) return;
    styleTag = el('style');
    styleTag.id = 'hiba-turkish-merged-styles';
    styleTag.textContent =
      'html[data-hiba-turkish-merged="ready"] product-info[data-product-handle="' + MAIN + '"] ' +
      '[data-hiba-high-variant-picker]{display:none!important;}' +
      'html[data-hiba-turkish-merged="ready"] product-info[data-product-handle="' + MAIN + '"] ' +
      '.product__page > product-images{display:none!important;}' +
      'html[data-hiba-turkish-merged="ready"] #hiba-exact-remote-gallery,' +
      'html[data-hiba-turkish-merged="ready"] #hiba-remote-gallery-overlay,' +
      'html[data-hiba-turkish-merged="ready"] #hiba-staged-remote-gallery-overlay,' +
      'html[data-hiba-turkish-merged="ready"] #hiba-seamless-remote-gallery{' +
        'display:none!important;visibility:hidden!important;pointer-events:none!important;}' +
      '#hiba-turkish-merged-picker{margin:20px 0 26px;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-label{' +
        'font-size:13px;font-weight:500;margin:10px 0 12px;color:#111;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-designs{' +
        'display:flex;flex-wrap:wrap;gap:10px;align-items:flex-start;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-design{' +
        'appearance:none;box-sizing:border-box;border:1px solid rgba(0,0,0,.19);' +
        'border-radius:8px;padding:0;overflow:hidden;background:#f6f6f6;' +
        'width:90px;height:90px;cursor:pointer;transition:border-color .15s;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-design[aria-pressed="true"]{' +
        'border:2px solid #111;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-design img{' +
        'width:100%;height:100%;object-fit:cover;display:block;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-colors{' +
        'display:flex;flex-wrap:wrap;align-items:center;gap:9px;min-height:20px;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-swatch{' +
        'appearance:none;display:flex;align-items:center;justify-content:center;' +
        'box-sizing:border-box;width:22px;height:22px;padding:3px;cursor:pointer;' +
        'border:0;border-radius:50%;background:transparent;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-swatch-dot{' +
        'display:block;box-sizing:border-box;border-radius:50%;width:16px;height:16px;' +
        'background:var(--hiba-turkish-swatch,#ddd);' +
        'box-shadow:inset 0 0 0 1px rgba(0,0,0,.12);}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-swatch[aria-pressed="true"]{' +
        'box-shadow:inset 0 0 0 1px #111,0 0 0 1px #111;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-swatch.is-unavailable{opacity:.4;}' +
      '#hiba-turkish-merged-picker .hiba-turkish-merged-availability{' +
        'margin-top:8px;font-size:13px;color:#a32424;}' +
      '#hiba-turkish-merged-gallery{display:block!important;min-width:0!important;' +
        'max-width:none!important;overflow:hidden!important;}' +
      '#hiba-turkish-merged-gallery .hiba-turkish-merged-gallery-list{' +
        'display:grid;grid-template-columns:repeat(2,minmax(0,1fr));' +
        'gap:8px;min-width:0;width:100%;}' +
      '#hiba-turkish-merged-gallery .hiba-turkish-merged-slide{min-width:0;overflow:hidden;}' +
      '#hiba-turkish-merged-gallery .hiba-turkish-merged-slide img{' +
        'display:block;width:100%;height:auto;aspect-ratio:3/4;object-fit:cover;}' +
      '@media(min-width:750px){.product__wrapper--stretch #hiba-turkish-merged-gallery{' +
        'margin-left:var(--outer-offset,0px);' +
        'width:calc(100% - var(--outer-offset,0px));max-width:none;}}' +
      '@media(max-width:749px){' +
        '#hiba-turkish-merged-picker .hiba-turkish-merged-design{width:72px;height:72px;}' +
        'html[data-hiba-turkish-merged="ready"] #hiba-turkish-merged-gallery{' +
          'margin-left:calc(0px - var(--outer,0px));' +
          'margin-right:calc(0px - var(--outer,0px));' +
          'width:calc(100% + var(--outer,0px) + var(--outer,0px));}' +
        'html[data-hiba-turkish-merged="ready"] #hiba-turkish-merged-gallery .hiba-turkish-merged-gallery-list{' +
          'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;' +
          'gap:0!important;grid-template-columns:none!important;' +
          'width:100%;overflow-x:auto;overflow-y:hidden;' +
          'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;}' +
        '#hiba-turkish-merged-gallery .hiba-turkish-merged-gallery-list::-webkit-scrollbar{display:none;}' +
        'html[data-hiba-turkish-merged="ready"] #hiba-turkish-merged-gallery .hiba-turkish-merged-slide{' +
          'flex:0 0 100%!important;width:100%!important;max-width:100%!important;' +
          'scroll-snap-align:start;scroll-snap-stop:always;}' +
      '}';
    document.head.appendChild(styleTag);
  }
  function activate() {
    var info = document.querySelector('product-info[data-product-handle="' + MAIN + '"]');
    if (!info) return false;
    picker = info.querySelector('[data-hiba-high-variant-picker]');
    originalGallery = document.querySelector('.product__page > product-images');
    if (!picker || !originalGallery || !originalGallery.parentNode) return false;
    if (!root) renderPicker();
    if (!gallery) makeGallery();
    if (!root.isConnected) picker.parentNode.insertBefore(root, picker);
    if (!gallery.isConnected) originalGallery.parentNode.insertBefore(gallery, originalGallery);
    addStyles();
    var query = new URLSearchParams(location.search);
    var initial = byVariant[query.get('variant')] ||
      allVariants.find(function (v) { return v.source === MAIN && v.available; }) ||
      allVariants.find(function (v) { return v.available; }) || allVariants[0];
    selectVariant(initial, true);
    document.documentElement.dataset.hibaTurkishMerged = 'ready';
    document.documentElement.dataset.hibaTurkishDesignCount = String(designs.length);
    document.documentElement.dataset.hibaTurkishVariantCount = String(allVariants.length);
    return true;
  }
  function scheduleSync() {
    if (updatePending) return;
    updatePending = true;
    setTimeout(function () {
      updatePending = false;
      if (!root || !root.isConnected || !gallery || !gallery.isConnected) return;
      synchronizeForm();
    }, 90);
  }
  document.addEventListener('submit', function (event) {
    if (!current || !event.target || !event.target.closest) return;
    var info = event.target.closest('product-info[data-product-handle="' + MAIN + '"]');
    if (!info || !event.target.matches('form[action*="/cart/add"]')) return;
    synchronizeForm();
    if (!current.available) {
      event.preventDefault();
      event.stopImmediatePropagation();
      root.querySelector('[data-hiba-turkish-availability]').textContent =
        'This color is currently unavailable.';
    }
  }, true);
  prepareCatalog().then(function () {
    var attempts = 0;
    function tryMount() {
      if (activate()) {
        var info = root.closest('product-info');
        if (info && !observer) {
          observer = new MutationObserver(scheduleSync);
          observer.observe(info, { subtree:true, childList:true });
        }
        return;
      }
      if (++attempts < 30) setTimeout(tryMount, 140);
      else window.__hibaTurkishMergedError = 'product-picker-mount-failed';
    }
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', tryMount, {once:true});
    else tryMount();
  }).catch(function (error) {
    window.__hibaTurkishMergedError = String(error && error.message || error);
    /* Intentional fallback: native Shopify picker stays fully functional. */
  });
})();